import React from "react";
import { ErrorBoundary } from "@components/Error/ErrorBoundary";
import { AuthLayout } from "@components/layouts/AuthLayout/AuthLayout";
import { InternalLayout } from "@components/layouts/InternalLayout/InternalLayout";
import { ScrollToTop } from "@components/ScrollToTop/ScrollToTop";
import { IS_APP_KYC_MODE, IS_MK_DEBT_MODE } from "@/constants";
import { sentryCreateBrowserRouter } from "@/sentry";
import { appKYCModeRouter } from "./appKYCModeRouter";
import { debtModeRouter } from "./debtModeRouter";
import { internalRoutes } from "./internalRoutes";
import { publicRoutes } from "./publicRoutes";

const PaymentStatusPage = React.lazy(() =>
  import("@pages/PaymentStatusPage/PaymentStatusPage").then((module) => ({
    default: module.PaymentStatusPage,
  })),
);

const LoginPage = React.lazy(() =>
  import("@pages/LoginPage/LoginPage").then((module) => ({
    default: module.LoginPage,
  })),
);

const VerificationStatusPage = React.lazy(() =>
  import("@pages/VerificationStatusPage/VerificationStatusPage").then(
    (module) => ({
      default: module.VerificationStatusPage,
    }),
  ),
);

export const router = (token?: string) => {
  if (IS_MK_DEBT_MODE) {
    return debtModeRouter();
  }

  if (IS_APP_KYC_MODE) {
    return appKYCModeRouter();
  }

  return sentryCreateBrowserRouter([
    {
      path: "/",
      errorElement: <ErrorBoundary />,
      element: <ScrollToTop />,
      children: [
        {
          element: token ? <InternalLayout /> : <AuthLayout />,
          children: [
            {
              path: "/login/new",
              element: (
                <React.Suspense fallback={<></>}>
                  <LoginPage />
                </React.Suspense>
              ),
            },
          ],
        },
        !token ? publicRoutes : {},
        token ? internalRoutes : {},
        {
          element: token ? <InternalLayout /> : <AuthLayout />,
          children: [
            {
              path: "/payment-status/:status",
              element: (
                <React.Suspense fallback={<></>}>
                  <PaymentStatusPage />
                </React.Suspense>
              ),
            },
            {
              path: "/verification/od/:status",
              element: (
                <React.Suspense fallback={<></>}>
                  <VerificationStatusPage />
                </React.Suspense>
              ),
            },
          ],
        },
      ],
    },
  ]);
};
